// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 360px;
}

.toast-message {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: center;
  padding: 0.95rem 1.1rem;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fb 100%);
  color: #1f2937;
  box-shadow: 0 14px 42px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.05);
  font-weight: 700;
  line-height: 1.4;
  animation: toastIn 0.25s ease;
  position: relative;
  overflow: hidden;
}

.toast-message::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(107, 64, 146, 0.05), transparent 40%), radial-gradient(circle at 80% 0%, rgba(244, 158, 85, 0.06), transparent 36%);
  pointer-events: none;
}

.toast-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: rgba(107, 64, 146, 0.14);
  color: var(--e-global-color-primary);
  position: relative;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
}

.toast-icon::after {
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: 16px;
  border: 1px dashed currentColor;
  opacity: 0.35;
  pointer-events: none;
}

.toast-message.success {
  border-color: rgba(107, 64, 146, 0.25);
}

.toast-message.success .toast-icon {
  background: linear-gradient(135deg, rgba(107, 64, 146, 0.16), rgba(180, 126, 220, 0.16));
  color: var(--e-global-color-primary);
}

.toast-message.error {
  border-color: rgba(181, 50, 138, 0.25);
}

.toast-message.error .toast-icon {
  background: linear-gradient(135deg, rgba(181, 50, 138, 0.16), rgba(255, 133, 83, 0.16));
  color: var(--e-global-color-accent);
}

.toast-message.info {
  border-color: rgba(244, 158, 85, 0.25);
}

.toast-message.info .toast-icon {
  background: linear-gradient(135deg, rgba(244, 158, 85, 0.16), rgba(107, 64, 146, 0.12));
  color: var(--e-global-color-secondary);
}

.toast-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.toast-title {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
  font-weight: 700;
}

.toast-copy {
  margin: 0;
  font-weight: 700;
  color: #111827;
  line-height: 1.5;
}

.toast-message.success .toast-title {
  color: var(--e-global-color-primary);
}

.toast-message.error .toast-title {
  color: var(--e-global-color-accent);
}

.toast-message.info .toast-title {
  color: var(--e-global-color-secondary);
}

@keyframes toastIn {
  from {
    transform: translateY(12px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/toast/toast.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6DAAA;EACA,cAAA;EACA,2CAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,uKAAA;EAEA,oBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,kBAAA;EACA,2CAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,oBAAA;AAAF;;AAGA;EACE,sCAAA;AAAF;;AAGA;EACE,wFAAA;EACA,oCAAA;AAAF;;AAGA;EACE,sCAAA;AAAF;;AAGA;EACE,uFAAA;EACA,mCAAA;AAAF;;AAGA;EACE,sCAAA;AAAF;;AAGA;EACE,uFAAA;EACA,sCAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,mCAAA;AAAF;;AAGA;EACE,sCAAA;AAAF;;AAGA;EACE;IACE,2BAAA;IACA,UAAA;EAAF;EAEA;IACE,wBAAA;IACA,UAAA;EAAF;AACF","sourcesContent":[".toast-container {\n  position: fixed;\n  bottom: 1rem;\n  right: 1rem;\n  z-index: 3000;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  max-width: 360px;\n}\n\n.toast-message {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: center;\n  padding: 0.95rem 1.1rem;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fb 100%);\n  color: #1f2937;\n  box-shadow: 0 14px 42px rgba(0, 0, 0, 0.12);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  font-weight: 700;\n  line-height: 1.4;\n  animation: toastIn 0.25s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.toast-message::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 20% 20%, rgba(107, 64, 146, 0.05), transparent 40%),\n    radial-gradient(circle at 80% 0%, rgba(244, 158, 85, 0.06), transparent 36%);\n  pointer-events: none;\n}\n\n.toast-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  background: rgba(107, 64, 146, 0.14);\n  color: var(--e-global-color-primary);\n  position: relative;\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);\n}\n\n.toast-icon::after {\n  content: '';\n  position: absolute;\n  inset: -6px;\n  border-radius: 16px;\n  border: 1px dashed currentColor;\n  opacity: 0.35;\n  pointer-events: none;\n}\n\n.toast-message.success {\n  border-color: rgba(107, 64, 146, 0.25);\n}\n\n.toast-message.success .toast-icon {\n  background: linear-gradient(135deg, rgba(107, 64, 146, 0.16), rgba(180, 126, 220, 0.16));\n  color: var(--e-global-color-primary);\n}\n\n.toast-message.error {\n  border-color: rgba(181, 50, 138, 0.25);\n}\n\n.toast-message.error .toast-icon {\n  background: linear-gradient(135deg, rgba(181, 50, 138, 0.16), rgba(255, 133, 83, 0.16));\n  color: var(--e-global-color-accent);\n}\n\n.toast-message.info {\n  border-color: rgba(244, 158, 85, 0.25);\n}\n\n.toast-message.info .toast-icon {\n  background: linear-gradient(135deg, rgba(244, 158, 85, 0.16), rgba(107, 64, 146, 0.12));\n  color: var(--e-global-color-secondary);\n}\n\n.toast-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.toast-title {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #6b7280;\n  font-weight: 700;\n}\n\n.toast-copy {\n  margin: 0;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.5;\n}\n\n.toast-message.success .toast-title {\n  color: var(--e-global-color-primary);\n}\n\n.toast-message.error .toast-title {\n  color: var(--e-global-color-accent);\n}\n\n.toast-message.info .toast-title {\n  color: var(--e-global-color-secondary);\n}\n\n@keyframes toastIn {\n  from {\n    transform: translateY(12px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
